import { Role } from '@/components/group-form-stepped/types'
import { CollaborationSettingsGroupRole, type GroupCollaborationSettingsFragment, GroupRole } from '@/graphql/generated'

export interface Roles {
  myGroupRole: CollaborationSettingsGroupRole
  otherGroupRole: CollaborationSettingsGroupRole
}

export const hasArtistSettings = (settings: GroupCollaborationSettingsFragment): boolean =>
  Boolean(
    settings?.platforms?.length > 0 ||
      settings?.genres?.length > 0 ||
      settings?.fixedFeeEnabled ||
      settings?.royaltyShareEnabled,
  )

export const hasInfluencerSettings = (settings: GroupCollaborationSettingsFragment): boolean =>
  Boolean(
    settings?.platforms?.length > 0 ||
      settings?.genres?.length > 0 ||
      settings?.fixedFeeEnabled ||
      settings?.royaltyShareEnabled,
  )

export const getRolesForGroup = (
  artistsCollaborationSettings: GroupCollaborationSettingsFragment,
  influencerCollaborationSettings: GroupCollaborationSettingsFragment,
): string[] => {
  const roles: string[] = []

  if (hasArtistSettings(artistsCollaborationSettings)) {
    roles.push('Music Maker')
  }

  if (hasInfluencerSettings(influencerCollaborationSettings)) {
    roles.push('Content Creator')
  }

  return roles
}

export const getRolesInCollaboration = (artistId: string, influencerId: string, myGroupId: string): Roles => {
  let myGroupRole: CollaborationSettingsGroupRole, otherGroupRole: CollaborationSettingsGroupRole
  const isArtist = artistId === myGroupId
  const isInfluencer = influencerId === myGroupId

  if (isArtist) {
    myGroupRole = CollaborationSettingsGroupRole.Artist
    otherGroupRole = CollaborationSettingsGroupRole.Influencer
  } else if (isInfluencer) {
    myGroupRole = CollaborationSettingsGroupRole.Influencer
    otherGroupRole = CollaborationSettingsGroupRole.Artist
  }
  return { myGroupRole, otherGroupRole }
}

export const getRoleName = (role: GroupRole): string => {
  switch (role) {
    case GroupRole.Artist:
      return 'Music Maker'
    case GroupRole.Influencer:
      return 'Content Creator'
    case GroupRole.Creative:
      return 'Creative'
    case GroupRole.Fan:
      return 'Fan / NFT collector'
    case GroupRole.Label:
      return 'Label'
    default:
      return '-'
  }
}

export function getRoleByValue(value: string): string | undefined {
  for (const [key, val] of Object.entries(Role)) {
    if (val === value) {
      return key
    }
  }
  return undefined
}
